import React, { useState, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import { Action, settingList } from './contants';
import { SettingItem } from './index.d';
import Switch from "react-switch";
import BrowserHistory from '@helpers/BrowserHistory';
import { isCubeApp, commandMessage } from '@helpers/Constants';
import NativeInterface from '@helpers/NativeInterface';
import useUrlParams from '@helpers/useUrlParams';
import FridayService from '@services/friday';

interface ItemProps {
  item: SettingItem;
  onEnable: (value: boolean) => void;
  switchStatus: boolean;
}

const Item = (props: ItemProps) => {
  const { item, switchStatus, onEnable } = props;
  const params = useUrlParams();

  const goToLocationSettingFrequentedPlace = () => {
    FridayService.addEvent(
      'real_time_location_more_location_settings_frequent_places_display',
      { source: '更多_定位设置_常去地点' },
    );
    BrowserHistory.push(`${PUBLIC_URL}/locationSettingFrequentedPlace?snCode=${params.sncode}&company=${params.company}`)
  }

  const clickItem = () => {
    if (item.action === Action.jump) {
        goToLocationSettingDetail();
    }
    if (item.action === Action.frequentedPlace) {
        goToLocationSettingFrequentedPlace();
    }
  }
  return (
    <div className="flex" styleName="item" onClick={ clickItem }>
      <div className="flex" styleName="item-title-left">
        <span styleName="item-title">{ item.title }</span>
        <span styleName="item-desc">{ item.desc }</span>
      </div>
      <div className="flex" styleName="item-icon-right">
        { item.action === Action.jump ?  <i styleName='right-arrow' className="iconfont icon-tubiaoyanse" /> : null}
        { item.action === Action.frequentedPlace ?  <i styleName='right-arrow' className="iconfont icon-tubiaoyanse" /> : null}
        { item.action === Action.switch ?
        <Switch
          styleName='border-switch'
          uncheckedIcon={ false }
          checkedIcon={ false }
          offColor={ '#ffffff' }
          onColor={ '#256eff' }
          boxShadow={ '0 0 1px 1px rgba(0, 0, 0, 0.2)' }
          activeBoxShadow={ '0 0 1px 1px rgba(0, 0, 0, 0.08)' }
          width={ 51 }
          height={ 28 }
          onChange={(checked) => onEnable(checked)} checked={switchStatus} /> : null}
        </div>
    </div>
  )
}

const goToLocationSettingDetail = () => {
    // displaySettingPopup(!showPopup);
    BrowserHistory.push(`${PUBLIC_URL}/locationsettingdetail`)
  }

const LocationSetting = () => {
  const params = useUrlParams();
  const [status, setSwitchStatus] = useState(false);

  const editSwitchStatus = async (enable: boolean) => {
    Http.post(Api.PostDeviceSwitchStatus,
      { snCode: params.sncode, company: params.company, key: 'locationSwitch', value: enable ? '1' : '0'}
    ).then(() => {
        setSwitchStatus(enable);
    })
  }

  const getLocationSwitchInfo = async() => {
    const result = await Http.post(Api.GetDeviceSwitchInfo,
      { snCode: params.sncode, company: params.company, key: 'locationSwitch' },{
        noMessage: true
      }
    );
    if(result && result.data) {
      setSwitchStatus(result.data === '1');
    }
  }

  const renderSettingItem = () => {
    const items = settingList.map((item: any, index: number) => {
      return (
        <Item key={ index } item={ item } onEnable={ editSwitchStatus } switchStatus={status} />
      )
      })

    return items;
  }

  useEffect(() => {
    getLocationSwitchInfo();
    // eslint-disable-next-line
  }, [])

  const toAuthUrl1 = async () => {
    const url = 'https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=1&index=4';
    if(isCubeApp()) { //在app环境中 跳转到外部小页面时需要打开新的webview容器
      NativeInterface.postMessage(commandMessage.openNewContainer, { url });
    } else {
      window.location.assign(url);
    }
  }

  const toAuthUrl2 = async () => {
    const url = 'https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=1&index=3';
    if(isCubeApp()) { //在app环境中 跳转到外部小页面时需要打开新的webview容器
      NativeInterface.postMessage(commandMessage.openNewContainer, { url });
    } else {
      window.location.assign(url);
    }
  }

  return (
    <div styleName="container">
      <NavBar
        title="定位设置"
        transparent
      />
      <div styleName="list">
        { renderSettingItem() }
      </div>
      <div styleName="bottomProtocol">
          <span onClick={ toAuthUrl1 }>{ '《授权使用声明》' }</span>
          <span onClick={ toAuthUrl2 }>{ '《个人信息使用授权同意书》' }</span>
        </div>
    </div>
  )
}

export default LocationSetting;
